import { PENGUINS_DATA } from "./panels/mock-data-penguins";
export const PLUGIN_ID = "1027276088284051809";

// Timeout constants in milliseconds
export const WIDGET_RENDER_TIMEOUT_MS = 5000; // 5 seconds
export const RENDERER_TIMEOUT_MS = 4500; // 4.5 seconds (slightly less than widget timeout)

export const MOCK_TABLE: Record<string, string> = {
  table1: `year,nests
2014,174
2015,322
2016,420
2017,540
2018,603
2019,732
2020,733
`,
  table2: JSON.stringify(PENGUINS_DATA),
};
